import { createUrlWithSourceQueryParams, customLocalStorage, parseQueryStrings } from "@crehana/utils";
function isValidEventType(eventType) {
    if (!eventType) {
        if ('development' === process.env.NODE_ENV) console.error('Amplitude eventType must be a non empty string');
        return false;
    }
    if ('string' != typeof eventType) {
        if ('development' === process.env.NODE_ENV) console.error(`Amplitude eventType must be a string, received: ${JSON.stringify(eventType)}`);
        return false;
    }
    if (eventType.match(/(\b[a-z]{3,}|\w[A-Z]{3,})|_|\./g)) {
        if ('development' === process.env.NODE_ENV) console.error(`Amplitude eventType must be a valid string, received: ${eventType}.
        remember to capitalize every word, ex: "Render Page"`);
        return false;
    }
    return true;
}
const getSourceEventParams = ()=>{
    const queryParams = parseQueryStrings(window.location.search);
    return {
        Source: 'string' == typeof queryParams?.source_page ? decodeURIComponent(queryParams.source_page) : 'Directo',
        'Source Detail': 'string' == typeof queryParams?.source_detail ? decodeURIComponent(queryParams.source_detail) : void 0
    };
};
const utils_createUrlWithSourceQueryParams = createUrlWithSourceQueryParams;
const showLogs = (logEventConfig)=>{
    if (customLocalStorage.getItem('amplitude_logger_enabled')) {
        const startGroup = console.group.bind(console);
        const endGroup = console.groupEnd.bind(console);
        const info = console.info.bind(console);
        startGroup('------ Sending amplitude log event ------');
        info('event:', logEventConfig.event);
        info('data:', logEventConfig.data);
        endGroup();
    }
};
const buildCentralizedUserProperties = (user)=>{
    const userProperties = {};
    userProperties['Organization Centralized Id'] = user.organization.id;
    userProperties['User Role'] = user.security.applicationRoles;
    userProperties['Products Available'] = user.security.applicationProducts;
    userProperties['User Application Roles'] = user.security.applicationRoles;
    userProperties['User Area'] = user.area?.name;
    userProperties['User Position'] = user.position?.name;
    userProperties['User Position Category'] = user.positionCategory?.name;
    userProperties['User Headquarter'] = user.headquarter?.name;
    return userProperties;
};
export { buildCentralizedUserProperties, getSourceEventParams, isValidEventType, showLogs, utils_createUrlWithSourceQueryParams as createUrlWithSourceQueryParams };
